import { render, staticRenderFns } from "./conflicts-table.vue?vue&type=template&id=2d689736&scoped=true&"
import script from "./conflicts-table.vue?vue&type=script&lang=js&"
export * from "./conflicts-table.vue?vue&type=script&lang=js&"
import style0 from "./conflicts-table.vue?vue&type=style&index=0&id=2d689736&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d689736",
  null
  
)

export default component.exports